import { createSplashFilters } from '@/filters/splashFilters'
import { extractFormData, extractZodFromForm } from '@/utils/forms'
import { ref } from 'vue'
import z from 'zod'

export function useSplashFilters() {
  const filters = createSplashFilters()
  const initValues = extractFormData(filters)
  const formData = ref({ ...initValues })
  const zodForm = z.object(extractZodFromForm(filters))

  return { formData, zodForm, filters }
}
